module.exports = __webpack_public_path__ + "img/listview-reallocatejob.b7edd4c4.svg";